import { render, staticRenderFns } from "./IdCardUpload.vue?vue&type=template&id=d17324fc&scoped=true"
import script from "./IdCardUpload.vue?vue&type=script&lang=js"
export * from "./IdCardUpload.vue?vue&type=script&lang=js"
import style0 from "./IdCardUpload.vue?vue&type=style&index=0&id=d17324fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17324fc",
  null
  
)

export default component.exports